<ng-container *ngIf="element?.context">
    <div class="ck-content" [innerHTML]="element.context.body"></div>
</ng-container>
